query OrganizationUser($id: ID!) {
  organizationUser(id: $id) {
    id
    roles
    disabled
    welcomeEmailSentAt
    createdAt
    user {
      id
      email
      displayName
    }
    invitedBy {
      id
      email
      displayName
    }
  }
}
